import type { PropsWithChildren } from 'react';

import styles from './Underline.module.css';

type UnderlineProps = PropsWithChildren;

export function Underline({ children }: UnderlineProps) {
  return <span className={styles.drawnUnderline}>{children}</span>;
}
